class FilterAccordions extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.itemEls = this.getItemEls()
    this.updateTabbableElements()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    if (!event.target.closest(this.els?.item?.selector)) return
    if (!event.target.closest(this.els?.trigger?.selector)) return

    const itemEl = event.target.closest(this.els?.item?.selector)

    if (this.dataset.type === 'oneopen') {
      this.itemEls.forEach((tempEl) => {
        if (tempEl !== itemEl) {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })
    }

    const contentEl = itemEl.querySelector(this.els?.content?.selector)
    const isTabbable = itemEl.getAttribute('aria-expanded') === 'true'

    itemEl.style.setProperty('--Max_Height', `${contentEl.offsetHeight}px`)
    itemEl.setAttribute('aria-expanded', !isTabbable)

    this.toggleTabbableElements(itemEl, !isTabbable)
  }

  updateTabbableElements () {
    this.itemEls = this.getItemEls()

    this.itemEls.forEach((itemEl) => {
      const isTabbable = itemEl.getAttribute('aria-expanded') === 'true'
      this.toggleTabbableElements(itemEl, isTabbable)
    })
  }

  toggleTabbableElements (itemEl, isTabbable) {
    const focusableSelectors =
      'button:not([data-filter-accordions-el="trigger"]), input'
    const focusableEls = window.BAO.Utils.getElements(focusableSelectors, {
      context: itemEl,
    })

    focusableEls.forEach((el) => {
      if (isTabbable === true) {
        el.removeAttribute('tabindex')
      } else {
        el.setAttribute('tabindex', '-1')
      }
    })
  }

  getItemEls () {
    return window.BAO.Utils.getElements(this.els.item.selector, {
      context: this,
    })
  }
}

if (!customElements.get('filter-accordions')) {
  customElements.define('filter-accordions', FilterAccordions)
}
